import { notification } from 'antd'

import CancelWhiteIcon from 'src/assets/cancel_white.svg'
import alerts from 'src/constants/alerts'

/**
 *
 * @param {"error" | "success" | "info" | "warning"} type
 * @param {string} message
 * @param {number} durationSeconds
 * @param {string} title
 * @returns {void}
 */
const openNotification = (
    type,
    message = `Whoops we didn't expect this, please try reloading this page`,
    durationSeconds = 3
) => {
    const msg = message
    let style = {}
    const key = `updatable-${Date.now()}`
    const duration = durationSeconds

    switch (type) {
        case alerts.ERROR:
            style = {
                ...style,
                color: '#FFFFFF',
                background: '#FF4747',
            }
            break
        case alerts.SUCCESS:
            style = {
                ...style,
                color: '#FFFFFF',
                background: '#2AC981',
            }
            break
        case alerts.WARNING:
            style = {
                ...style,
                color: '#FFFFFF',
                background: '#FA9917',
            }
            break
        case alerts.INFO:
        default:
            style = {
                ...style,
                color: '#FFFFFF',
                background: '#2F3B52',
            }
            break
    }

    notification.open({
        message: null,
        key: key,
        description: msg,
        duration: duration,
        style: style,
        closeIcon: <img src={CancelWhiteIcon} width="25" height="25" />,
    })

    setTimeout(() => {
        notification.close(key)
    }, duration * 1000)
}

export default openNotification
